// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"1c527348","422":"64473691","533":"278fe02b","648":"c5b3d098","973":"7a69b85b"}[chunkId] + ".chunk.js";
};